/**
 * Created by win10 on 2017/9/20.
 */
const lang = navigator.language || navigator.userLanguage;
const isEn = lang == "en" || lang == "en-us" || lang == "en-US";
console.log("lang", lang, "isEn", isEn);
const state = {
  include: [], //缓存路由name
  axiosPing: [], // 接口防止重复请求
  loading: false, // 全局loading
  platformInfo: {}, // 平台信息
  usableMoney: {}, // 余额类型
  userInfo: {}, // 用户信息
  backFlag: false, //路由返回
  language: localStorage.getItem("language")
    ? localStorage.getItem("language")
    : isEn
    ? "en"
    : "zh", // 多语言
  token: localStorage.getItem("token") ? localStorage.getItem("token") : "" // 登录状态
};
export default state;
